import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import ReportService from '../../../services/reports';
import { normalizeReportParams } from '../../../helpers/reportQuery';
import {
  normalizeReportsExtrasVariationsPayload,
  normalizePaginationBlock,
} from '../../../helpers/normalizeReportsAdminResponse';

const emptyPag = normalizePaginationBlock({});

const initialState = {
  loading: false,
  extrasData: [],
  extrasPagination: emptyPag,
  variationsData: [],
  variationsPagination: emptyPag,
  snapshotNote: '',
  error: '',
};

export const fetchReportsExtrasVariations = createAsyncThunk(
  'report/fetchReportsExtrasVariations',
  (params = {}) =>
    ReportService.getReportsExtrasVariations(
      normalizeReportParams({ ...params, format: 'json', view: 'full' })
    ).then((res) => res)
);

const extrasSlice = createSlice({
  name: 'extrasReport',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchReportsExtrasVariations.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchReportsExtrasVariations.fulfilled, (state, action) => {
      state.loading = false;
      const n = normalizeReportsExtrasVariationsPayload(action.payload);
      state.extrasData = n.extrasData;
      state.extrasPagination = n.extrasPagination;
      state.variationsData = n.variationsData;
      state.variationsPagination = n.variationsPagination;
      state.snapshotNote = n.snapshotNote;
      state.error = '';
    });
    builder.addCase(fetchReportsExtrasVariations.rejected, (state, action) => {
      state.loading = false;
      state.extrasData = [];
      state.variationsData = [];
      state.error = action.error.message;
    });
  },
});

export default extrasSlice.reducer;
